import ReactGA from "react-ga";

export const initGA = () => {
  // Keep in Vercel production env var to avoid tracking visits during development
  ReactGA.initialize("UA-65623566-4");
  // ReactGA.ga("require", "GTM-NR267TL");
};

export const logPageView = (pathname) => {
  ReactGA.set({page: pathname});
  ReactGA.pageview(pathname, ['terminal_reader']);
};

export const logEvent = ({category = "", action = "", label, nonInteraction}) => {
  if (category && action) {
    ReactGA.event({
      category,
      action,
      ...(label && {label}),
      ...(nonInteraction && {nonInteraction}),
    });
  }
};

export const logException = (description = "", fatal = false) => {
  if (description) {
    ReactGA.exception({description, fatal});
  }
};